import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    apiUploadXlsxSuccess: {
        id: 'iaso.polio.notifications.api.upload_xlsx_success',
        defaultMessage:
            'Success. Please wait a few moments then refresh the page.',
    },
    labelActions: {
        id: 'iaso.polio.notifications.label.actions',
        defaultMessage: 'Actions',
    },
    labelClosestMatchVdpv2: {
        id: 'iaso.polio.notifications.label.closest_match_vdpv2',
        defaultMessage: 'Closest match',
    },
    labelCountry: {
        id: 'iaso.polio.notifications.label.country',
        defaultMessage: 'Country',
    },
    labelDateOfOnset: {
        id: 'iaso.polio.notifications.label.date_of_onset',
        defaultMessage: 'Date of onset',
    },
    labelDateOfOnsetAfter: {
        id: 'iaso.polio.notifications.label.date_of_onset_after',
        defaultMessage: 'Onset date from',
    },
    labelDateOfOnsetBefore: {
        id: 'iaso.polio.notifications.label.date_of_onset_before',
        defaultMessage: 'Onset date to',
    },
    labelDateResultsReceived: {
        id: 'iaso.polio.notifications.label.date_results_received',
        defaultMessage: 'Date results received',
    },
    labelDistrict: {
        id: 'iaso.polio.notifications.label.district',
        defaultMessage: 'District',
    },
    labelEpid: {
        id: 'iaso.polio.notifications.label.epid',
        defaultMessage: 'EPID number',
    },
    labelId: {
        id: 'iaso.polio.notifications.label.id',
        defaultMessage: 'ID',
    },
    labelLineage: {
        id: 'iaso.polio.notifications.label.lineage',
        defaultMessage: 'Lineage',
    },
    labelOrgUnit: {
        id: 'iaso.polio.notifications.label.org_unit',
        defaultMessage: 'Org Unit',
    },
    labelProvince: {
        id: 'iaso.polio.notifications.label.province',
        defaultMessage: 'Province',
    },
    labelSiteName: {
        id: 'iaso.polio.notifications.label.site_name',
        defaultMessage: 'Site name',
    },
    labelSource: {
        id: 'iaso.polio.notifications.label.source',
        defaultMessage: 'Source',
    },
    labelVdpvCategory: {
        id: 'iaso.polio.notifications.label.vdpv_category',
        defaultMessage: 'VDPV category',
    },
    labelVdpvNucleotideDiffSabin2: {
        id: 'iaso.polio.notifications.label.vdpv_nucleotide_diff_sabin2',
        defaultMessage: 'VDPV nucleotide diff SABIN2',
    },
    modalAddTitle: {
        id: 'iaso.polio.notifications.modal.add.title',
        defaultMessage: 'Add notification',
    },
    modalBulkImportXlsxBackgroundWarning: {
        id: 'iaso.polio.notifications.modal.bulk_import.background_warning',
        defaultMessage:
            'The import will be processed in the background and the data will be visible after a few minutes.',
    },
    modalBulkImportSelectXlsxFile: {
        id: 'iaso.polio.notifications.modal.bulk_import.select_xlsx_file',
        defaultMessage: 'Select .xlsx file',
    },
    modalBulkImportTitle: {
        id: 'iaso.polio.notifications.modal.bulk_import.title',
        defaultMessage: 'Import notifications',
    },
    modalBulkImportXlsxFileFormat: {
        id: 'iaso.polio.notifications.modal.bulk_import.xlsx_file_format',
        defaultMessage:
            'Select a Microsoft Excel file (.xlsx) with a format similar to the example below.',
    },
    modalDeleteConfirm: {
        id: 'iaso.polio.notifications.modal.delete.confirm',
        defaultMessage: 'Do you really want to delete this notification?',
    },
    modalDeleteNo: {
        id: 'iaso.polio.modal.no',
        defaultMessage: 'No',
    },
    modalDeleteTitle: {
        id: 'iaso.polio.notifications.modal.delete.title',
        defaultMessage: 'Delete notification',
    },
    modalDeleteYes: {
        id: 'iaso.polio.modal.yes',
        defaultMessage: 'Yes',
    },
    modalEditTitle: {
        id: 'iaso.polio.notifications.modal.edit.title',
        defaultMessage: 'Edit notification',
    },
    modalWriteCancel: {
        id: 'iaso.polio.notifications.modal.write.cancel',
        defaultMessage: 'Cancel',
    },
    modalWriteConfirm: {
        id: 'iaso.polio.notifications.modal.write.confirm',
        defaultMessage: 'Confirm',
    },
    notificationsTitle: {
        id: 'iaso.polio.notifications.title',
        defaultMessage: 'Virus notification',
    },
    validationFieldRequired: {
        id: 'iaso.polio.notifications.validation.field_required',
        defaultMessage: 'This field is required',
    },
    validationInvalidDate: {
        id: 'iaso.polio.notifications.validation.invalid_date',
        defaultMessage: 'Invalid date',
    },
});

export default MESSAGES;
